import { RootState } from 'reduxStore/types';

export const getIsResetUploadFileInputErrorMessage = (state: RootState) =>
  state.common.isResetUploadFileInputErrorMessage;
